// extracted by mini-css-extract-plugin
export var action_button = "styles-module--action_button--920cb";
export var actions_bar = "styles-module--actions_bar--b7572";
export var button_ad = "styles-module--button_ad--179a8";
export var colors_controls = "styles-module--colors_controls--6774c";
export var colors_scale = "styles-module--colors_scale--3017e";
export var delete_button = "styles-module--delete_button--f7efb";
export var gradient_result = "styles-module--gradient_result--01d88";
export var gradient_type_button = "styles-module--gradient_type_button--bd646";
export var gradient_type_button_active = "styles-module--gradient_type_button_active--66812";
export var gradient_type_selector = "styles-module--gradient_type_selector--61ae3";
export var heading = "styles-module--heading--f3145";
export var orientation_select = "styles-module--orientation_select--de8cf";
export var preset_button = "styles-module--preset_button--840c5";
export var presets_container = "styles-module--presets_container--f3cb9";
export var presets_grid = "styles-module--presets_grid--d7198";
export var settings = "styles-module--settings--361cd";
export var toast = "styles-module--toast--61297";
export var toastIn = "styles-module--toastIn--88361";
export var wrapper = "styles-module--wrapper--90782";
export var wrapper_grid = "styles-module--wrapper_grid--894ff";